import React, { useEffect, useState } from "react"
import PageContainer from "../../../components/PageContainer"
import { useHistory, useRouteMatch } from "react-router-dom/cjs/react-router-dom.min";
import { FaPen, FaPlus, FaSave, FaTrash } from "react-icons/fa";
import { MdClose, MdOutlineArrowBack } from "react-icons/md";
import { Button, Card, Col, Form, InputGroup, Row, Tab, Tabs } from "react-bootstrap";
import ClienteoApiService from "../../../services/api/CadastroClientesService";
import ConvertDataService from "../../../services/util/ConvertDatas";
import TabelaPlanejamentoFuncoes from "../../../components/TabelaPlanejamentoFuncoes";
import TabelaPlanejamentoIndiretos from "../../../components/TabelaPlanejamentoIndiretos";
import DatePicker from 'react-datepicker';
import CustosPrevistosService from "../../../services/api/CustosPrevistosService";
import Loading from "../../../components/Loading";
import useAlertNotification from "../../../context/AlertNotificationContext";
import TabelaPlanejamentoTotal from "../../../components/TabelaPlanejamentoTotal";
import CompareData from "../../../services/util/CompareData";
import CustomModal from "../../../components/CustomModal";
import { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";

function ProjetoPrevistoView() {

    registerLocale("pt-BR", ptBR);

    // Hooks
    const history = useHistory();
    const alert = useAlertNotification();

    // mês e ano atual
    const getCurrentMesAno = () => {
        const now = new Date();
        const mes = String(now.getMonth() + 1).padStart(2, '0');
        const ano = now.getFullYear();
        return `${mes}-${ano}`;
    };
    const currentMesAno = getCurrentMesAno();

    // Estados
    const [isLoading, setIsLoading] = useState(false);
    const [edit, setEdit] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [todosClientes, setTodosClientes] = useState([]);
    const [checkCopy, setCheckCopy] = useState(false);
    const [dadosPlanejamento, setDadosPlanejamento] = useState({
        "meses": {
            [currentMesAno]: {
                "valorVenda": null,
                "total_previsto_funcao": {
                    "soma_horas_funcao": 0,
                    "soma_custo_total_funcao": 0
                },
                "total_previsto_indireto": 0,
                "previstoFuncao": [],
                "previstoIndireto": []
            },
        },
        "previstoTotal": {
            "id": null,
            "total_custo_indireto": 0,
            "total_horas": 0,
            "total_funcao": 0,
            "total_custo_venda": 0,
            "total": 0,
            "projeto": "",
            "total_valor_venda": 0,
            "margem_custo_projeto": 0
        },
        "cliente": {
            "id": null,
            "nome": "",
            "chave": ""
        }
    });
    const [originalData, setOriginalData] = useState({});
    const [currentTab, setCurrentTab] = useState(Object.keys(dadosPlanejamento.meses)[0]);
    const [allFuncoes, setAllFuncoes] = useState([]);
    const [allCustosIndiretos, setAllCustosIndiretos] = useState([]);

    // Hooks
    const match = useRouteMatch();
    const { key } = match.params;

    // Busca todos os clientes
    const getClientsList = async () => {
        try {
            const data = await ClienteoApiService.getClientAll();
            setTodosClientes(data.data);
        } catch (error) {
            console.error('Erro ao chamar todos os clientes:', error);
        }
    };

    // Busca o planejamento
    const getPredictedCost = async () => {
        setIsLoading(true);
        try {
            const resp = await CustosPrevistosService.getAllPlanejamento(key);
            setOriginalData(JSON.parse(JSON.stringify(resp.data)));
            setDadosPlanejamento({...dadosPlanejamento, cliente: {
                id: resp.data.cliente.id,
                nome: resp.data.cliente.nome,
                chave: resp.data.cliente.chave
            }});
            if (Object.keys(resp.data.meses).length > 0) {
                setDadosPlanejamento(resp.data);
                setCurrentTab(Object.keys(resp.data.meses)[0]);
            }
        } catch (error) {
            console.error("Erro ao buscar valor venda.", error);
        } finally {
            setIsLoading(false);
        }
    }

    // Salva os dados
    const saveData = async () => {
        const validations = CompareData.Validations(dadosPlanejamento);
        if (validations.validate) {
            const dataToSave = CompareData.ComparePlanejamento(originalData, dadosPlanejamento, key);
            try {
                setIsSaving(true);
                const resp = await CustosPrevistosService.manageResource(dataToSave);
                alert.success("Planejamento da venda salvo com sucesso!");
                setEdit(false);
                setCheckCopy(false);
                await getPredictedCost();

            } catch (error) {
                console.error("Erro ao salvar os dados: ", error);
                if (error.response && error.response.data) {
                    const mensagemErro = error.response.data.message || JSON.stringify(error.response.data);
                    alert.error(`Erro da API: ${mensagemErro}`);
                } else if (error.message) {
                    alert.error(`Erro inesperado: ${error.message}`);
                } else {
                    alert.error("Erro desconhecido ao salvar os dados.");
                }
            } finally {
                setIsSaving(false);
            }
        } else {
            alert.error(`Erro: ${validations.message}`);
        }
    };

    // Função para atualizar allFuncoes
    const updateAllFuncoes = () => {
        const todasFuncoes = Object.values(dadosPlanejamento.meses).reduce((acc, mes) => {
            return [...acc, ...mes.previstoFuncao];
        }, []);
        setAllFuncoes(todasFuncoes);
    };

    // Função para atualizar allCustosIndiretos
    const updateAllCustosIndiretos = () => {
        const todosCustosIndiretos = Object.values(dadosPlanejamento.meses).reduce((acc, mes) => {
            return [...acc, ...mes.previstoIndireto];
        }, []);
        setAllCustosIndiretos(todosCustosIndiretos);
    };

    // Efeitos de inicio
    useEffect(() => {
        getClientsList();
        getPredictedCost();
    }, []);

    // Efeito para atualizar allFuncoes e allCustosIndiretos quando dadosPlanejamento mudar
    useEffect(() => {
        updateAllFuncoes();
        updateAllCustosIndiretos();
    }, [dadosPlanejamento]);

    // Função para criar um novo mês
    const newTab = () => {
        const newTabKey = ConvertDataService.getNextMonthYear(Object.keys(dadosPlanejamento.meses)[Object.keys(dadosPlanejamento.meses).length - 1]);
        const estruturaVazia = {
            previstoFuncao: [],
            previstoIndireto: [],
            total_previsto_funcao: {
                soma_horas_funcao: 0,
                soma_custo_total_funcao: 0
            },
            total_previsto_indireto: 0,
            valorVenda: null
        };
        const dataNewTab = {
            ...dadosPlanejamento,
            meses: {
                ...dadosPlanejamento.meses,
                [newTabKey]: estruturaVazia
            }
        };
        setDadosPlanejamento(dataNewTab);
        setCurrentTab(newTabKey);
    };

    // Função para duplicar um mês
    const copyTab = () => {
        const newTabKey = ConvertDataService.getNextMonthYear(
            Object.keys(dadosPlanejamento.meses)[Object.keys(dadosPlanejamento.meses).length - 1]
        );

        const mesOriginal = dadosPlanejamento.meses[currentTab];
        const mesCopiado = {
            previstoFuncao: mesOriginal.previstoFuncao.map((func, index) => ({
                ...func,
                id: index,
                mes_ano: newTabKey
            })),
            previstoIndireto: mesOriginal.previstoIndireto.map((ind) => ({
                ...ind,
                mes_ano: newTabKey
            })),
            total_previsto_funcao: {
                soma_horas_funcao: mesOriginal.total_previsto_funcao.soma_horas_funcao,
                soma_custo_total_funcao: mesOriginal.total_previsto_funcao.soma_custo_total_funcao
            },
            total_previsto_indireto: mesOriginal.total_previsto_indireto,
            valorVenda: mesOriginal.valorVenda
        };

        const dataNewTab = {
            ...dadosPlanejamento,
            meses: {
                ...dadosPlanejamento.meses,
                [newTabKey]: mesCopiado
            }
        };

        setDadosPlanejamento(dataNewTab);
        setCurrentTab(newTabKey);
    };

    // Função para deletar um mês
    const deleteTab = () => {
        const newTabs = { ...dadosPlanejamento.meses };
        const tabKeys = Object.keys(newTabs).sort((a, b) => {
            const [mesA, anoA] = a.split('-').map(Number);
            const [mesB, anoB] = b.split('-').map(Number);
            return new Date(anoA, mesA - 1) - new Date(anoB, mesB - 1);
        });
        const currentIndex = tabKeys.indexOf(currentTab);
        if (Object.keys(newTabs).length > 1) {
            delete newTabs[currentTab];
        }
        let nextTab;
        if (currentIndex == 0) {
            nextTab = tabKeys[1] || '';
        } else {
            nextTab = tabKeys[currentIndex - 1];
        }
        setDadosPlanejamento({ ...dadosPlanejamento, meses: newTabs });
        setCurrentTab(nextTab);
    };

    // Função para alterar a chave do mês e do ano e reorganizar o objeto
    const changeMonthYearKey = (mesAnoAtual, novoMesAno) => {
        const novoMesAnoFormatado = ConvertDataService.convertDataToMMyyyyStr(novoMesAno);
    
        if (dadosPlanejamento.meses.hasOwnProperty(mesAnoAtual)) {
            const mesDataOriginal = dadosPlanejamento.meses[mesAnoAtual];
    
            // Atualizar o campo "mes_ano" dentro dos arrays previstoFuncao e previstoIndireto
            const mesDataAtualizado = {
                ...mesDataOriginal,
                previstoFuncao: mesDataOriginal.previstoFuncao.map(func => ({
                    ...func,
                    mes_ano: novoMesAnoFormatado
                })),
                previstoIndireto: mesDataOriginal.previstoIndireto.map(ind => ({
                    ...ind,
                    mes_ano: novoMesAnoFormatado
                }))
            };
    
            const novosMeses = { ...dadosPlanejamento.meses };
            delete novosMeses[mesAnoAtual];
            novosMeses[novoMesAnoFormatado] = mesDataAtualizado;
    
            const mesesOrdenados = Object.keys(novosMeses)
                .sort((a, b) => {
                    const [mesA, anoA] = a.split('-').map(Number);
                    const [mesB, anoB] = b.split('-').map(Number);
                    return new Date(anoA, mesA - 1) - new Date(anoB, mesB - 1);
                })
                .reduce((acc, key) => {
                    acc[key] = novosMeses[key];
                    return acc;
                }, {});
    
            setDadosPlanejamento((prevState) => ({
                ...prevState,
                meses: mesesOrdenados
            }));
    
            setCurrentTab(novoMesAnoFormatado);
        } else {
            console.error(`Mês ${mesAnoAtual} não encontrado.`);
        }
    };

    // Função para verificar se um mês já está cadastrado
    const isExcludedMonth = (date) => {
        const monthYear = `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
        return Object.keys(dadosPlanejamento.meses).includes(monthYear);
    };

    // Função para formatar o valor
    const formatarMoeda = (value) => {
        if (!value) return '';
        const clenedValue = value.toString().replace(/\D/g, '');
        const num = parseFloat(clenedValue) / 100;

        return num.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    const actions = [
        (!edit ? {
            label: 'Editar',
            icon: <FaPen />,
            color: 'primary',
            type: 'button',
            onClick: () => setEdit(true)
        } : {
            label: isSaving ? 'Salvando...' : 'Salvar',
            icon: <FaSave />,
            color: 'success',
            type: 'button',
            disabled: isSaving,
            onClick: saveData
        }),
        (!edit ? {
            label: 'Voltar',
            icon: <MdOutlineArrowBack />,
            color: 'info',
            type: 'button',
            onClick: () => history.goBack()
        } : {
            label: 'Cancelar',
            icon: <MdClose />,
            color: 'danger',
            type: 'button',
            onClick: () => window.location.reload()
        }),
    ];

    const title = `Planejamento Financeiro da Venda - ${key}`

    return (
        <PageContainer title={title} actions={actions}>
            {isLoading ? <Loading message="Carregando..." /> :
                <>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center">
                            <h5 className="mb-0">Cliente:  </h5>
                            <Form.Control
                                disabled={!edit}
                                as="select"
                                name="clientes"
                                value={dadosPlanejamento.cliente.nome}
                                onChange={(e) => {
                                    const clienteSelecionado = todosClientes.find(cliente => cliente.name === e.target.value);
                                    if (clienteSelecionado) {
                                        setDadosPlanejamento({
                                            ...dadosPlanejamento,
                                            cliente: {
                                                id: clienteSelecionado.id,
                                                nome: clienteSelecionado.name,
                                                chave: clienteSelecionado.key
                                            }
                                        });
                                    } else {
                                        setDadosPlanejamento({
                                            ...dadosPlanejamento,
                                            cliente: {
                                                id: null,
                                                nome: '',
                                                chave: null
                                            }
                                        });
                                    }
                                }}
                                className="ml-3">
                                <option value="">--Cliente--</option>
                                {todosClientes.map(cliente => {
                                    return <option key={cliente.id} value={cliente.name}>{cliente.name}</option>
                                })}
                            </Form.Control>
                        </div>
                        <InputGroup style={{ width: "auto" }}>
                            <h5 className="d-flex align-self-center mb-0 mr-3">Margem Líquida Prevista na venda: </h5>
                            <Form.Control
                                type="number"
                                maxLength={10}
                                style={{
                                    textAlign: "right",
                                    flex: "0 0 auto",
                                    width: `${Math.max(5, String(dadosPlanejamento.previstoTotal?.margem_custo_projeto ?? "").length + 3)}ch`
                                }}
                                disabled={!edit}
                                placeholder="00.00"
                                aria-label="Valor"
                                aria-describedby="basic-addon2"
                                value={dadosPlanejamento.previstoTotal?.margem_custo_projeto}
                                onChange={(e) => {
                                    setDadosPlanejamento({
                                        ...dadosPlanejamento,
                                        previstoTotal: {
                                            ...dadosPlanejamento.previstoTotal,
                                            margem_custo_projeto: e.target.value
                                        }
                                    })
                                }}
                                className="no-arrows"
                            /><InputGroup.Text id="basic-addon2">%</InputGroup.Text>
                        </InputGroup>
                    </div>
                    <hr />
                    {edit && (
                        <>
                            <Form className="mb-3 d-flex align-items-center">
                                <Form.Check
                                    type="checkbox"
                                    label="Copiar dados do mês atual"
                                    checked={checkCopy}
                                    onChange={() => setCheckCopy(!checkCopy)}
                                />
                                {!checkCopy ?
                                    <Button onClick={newTab} className="ml-2" disabled={!edit}>
                                        <FaPlus /> Adicionar mês
                                    </Button>
                                    : <Button onClick={copyTab} className="ml-2" disabled={!edit}>
                                        <FaPlus /> Adicionar mês copiado
                                    </Button>}

                                <Button variant="danger" className="ml-2" onClick={deleteTab} disabled={!edit || Object.keys(dadosPlanejamento.meses).length <= 1}>
                                    <FaTrash /> Excluir mês
                                </Button>
                            </Form>
                        </>
                    )}
                    <Tabs activeKey={currentTab}
                        onSelect={(key) => setCurrentTab(key)}>
                        {Object.entries(dadosPlanejamento.meses).map(([mesAno, valores]) => (
                            <Tab key={mesAno} eventKey={mesAno} title={`${mesAno.split('-')[0]}/${mesAno.split('-')[1]}`}>
                                <DatePicker
                                    className="mb-3 mt-3"
                                    selected={ConvertDataService.convertDataMMYYYYstrToData(mesAno)}
                                    onChange={(e) => {
                                        changeMonthYearKey(mesAno, e);
                                    }}
                                    locale="pt-BR"
                                    dateFormat="MMMM / yyyy"
                                    disabled={!edit}
                                    showMonthYearPicker
                                    filterDate={(date) => !isExcludedMonth(date)}
                                />
                                <Form className="mb-3">
                                    <InputGroup style={{ width: "300px", marginBottom: "15px" }}>
                                        <h5 className="d-flex align-self-center mb-0 mr-3">Valor venda: </h5>
                                        <InputGroup.Text id="basic-addon2">R$</InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            disabled={!edit}
                                            placeholder="00.00"
                                            aria-label="Valor"
                                            aria-describedby="basic-addon2"
                                            value={valores.valorVenda ? formatarMoeda(valores.valorVenda) : ''}
                                            onChange={(e) => {
                                                setDadosPlanejamento({
                                                    ...dadosPlanejamento,
                                                    meses: {
                                                        ...dadosPlanejamento.meses,
                                                        [mesAno]: {
                                                            ...dadosPlanejamento.meses[mesAno],
                                                            valorVenda: formatarMoeda(e.target.value).replaceAll('.', '').replace(',', '.') > 0 ? formatarMoeda(e.target.value).replaceAll('.', '').replace(',', '.') : null
                                                        }
                                                    }
                                                })
                                            }}
                                            onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault() }}
                                            className="no-arrows"
                                        />
                                    </InputGroup>
                                    <InputGroup style={{width: "300px"}}>
                                        <h5 className="d-flex align-self-center mb-0 mr-4">Total custo: </h5>
                                        <InputGroup.Text id="basic-addon2">R$</InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            disabled="true"
                                            aria-label="Valor"
                                            aria-describedby="basic-addon2"
                                            value={(valores.total_previsto_funcao?.soma_custo_total_funcao + valores.total_previsto_indireto || 0)?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}/>

                                    </InputGroup>
                                </Form>
                                <Row className="mt-1">
                                    <Col>
                                        <TabelaPlanejamentoFuncoes currentTab={mesAno} edit={edit} funcoes={valores.previstoFuncao} total={valores.total_previsto_funcao} dadosPlanejamento={dadosPlanejamento} setDadosPlanejamento={setDadosPlanejamento} allFuncoes={allFuncoes} />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col>
                                        <TabelaPlanejamentoIndiretos currentTab={mesAno} edit={edit} indiretos={valores.previstoIndireto} total={valores.total_previsto_indireto} dadosPlanejamento={dadosPlanejamento} setDadosPlanejamento={setDadosPlanejamento} allCustosIndiretos={allCustosIndiretos} />
                                    </Col>
                                </Row>
                                {/* <Card className="p-3">
                                    <Row>
                                        <Col>
                                            <p className="m-0"><strong>Total do mês: </strong>{(valores.total_previsto_funcao?.soma_custo_total_funcao + valores.total_previsto_indireto || 0)?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
                                        </Col>
                                    </Row>
                                </Card> */}
                            </Tab>
                        ))}
                        <Tab eventKey={0} title="Total">
                            < TabelaPlanejamentoTotal dadosPlanejamento={dadosPlanejamento} />
                        </Tab>
                    </Tabs>
                </>}
            <CustomModal />
        </PageContainer>
    )
}

export default ProjetoPrevistoView;
